const images = [
  {
    thumb: require("../../../assets/collection/old_oak/albin.jpg"),
    src: require("../../../assets/collection/old_oak/albin.jpg"),
    caption: "Albin",
    srcset: require("../../../assets/collection/old_oak/albin.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/old_oak/dab_fatim.jpg"),
    src: require("../../../assets/collection/old_oak/dab_fatim.jpg"),
    caption: "Dąb fatm",
    srcset: require("../../../assets/collection/old_oak/dab_fatim.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/old_oak/dab_omar.jpg"),
    src: require("../../../assets/collection/old_oak/dab_omar.jpg"),
    caption: "Dąb Omar",
    srcset: require("../../../assets/collection/old_oak/dab_omar.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/old_oak/dab_samir.jpg"),
    src: require("../../../assets/collection/old_oak/dab_samir.jpg"),
    caption: "Dąb Samir",
    srcset: require("../../../assets/collection/old_oak/dab_samir.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/old_oak/dab_saymon.jpg"),
    src: require("../../../assets/collection/old_oak/dab_saymon.jpg"),
    caption: "Dąb Saymon",
    srcset: require("../../../assets/collection/old_oak/dab_saymon.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/old_oak/dab_wasim.jpg"),
    src: require("../../../assets/collection/old_oak/dab_wasim.jpg"),
    caption: "Dąb Wasim",
    srcset: require("../../../assets/collection/old_oak/dab_wasim.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/old_oak/fars.jpg"),
    src: require("../../../assets/collection/old_oak/fars.jpg"),
    caption: "Fars",
    srcset: require("../../../assets/collection/old_oak/fars.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/old_oak/hektor.jpg"),
    src: require("../../../assets/collection/old_oak/hektor.jpg"),
    caption: "Hektor",
    srcset: require("../../../assets/collection/old_oak/hektor.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/old_oak/mars.jpg"),
    src: require("../../../assets/collection/old_oak/mars.jpg"),
    caption: "Mars",
    srcset: require("../../../assets/collection/old_oak/mars.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/old_oak/milan.jpg"),
    src: require("../../../assets/collection/old_oak/milan.jpg"),
    caption: "Milan",
    srcset: require("../../../assets/collection/old_oak/milan.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/old_oak/opal_sloneczny.jpg"),
    src: require("../../../assets/collection/old_oak/opal_sloneczny.jpg"),
    caption: "Opal Słoneczny",
    srcset: require("../../../assets/collection/old_oak/opal_sloneczny.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/old_oak/patyna.jpg"),
    src: require("../../../assets/collection/old_oak/patyna.jpg"),
    caption: "Patyna",
    srcset: require("../../../assets/collection/old_oak/patyna.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/old_oak/viggo.jpg"),
    src: require("../../../assets/collection/old_oak/viggo.jpg"),
    caption: "Viggo",
    srcset: require("../../../assets/collection/old_oak/viggo.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/old_oak/viggo_crudo.jpg"),
    src: require("../../../assets/collection/old_oak/viggo_crudo.jpg"),
    caption: "Vigo Crudo",
    srcset: require("../../../assets/collection/old_oak/viggo_crudo.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/old_oak/viggo_royal.jpg"),
    src: require("../../../assets/collection/old_oak/viggo_royal.jpg"),
    caption: "Viggo Royal",
    srcset: require("../../../assets/collection/old_oak/viggo_royal.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/old_oak/walter.jpg"),
    src: require("../../../assets/collection/old_oak/walter.jpg"),
    caption: "Walter",
    srcset: require("../../../assets/collection/old_oak/walter.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/old_oak/dab_teviot.jpg"),
    src: require("../../../assets/collection/old_oak/dab_teviot.jpg"),
    caption: "Dąb Teviot",
    srcset: require("../../../assets/collection/old_oak/dab_teviot.jpg"),
    description: ""
  }
];

export default images;
